import React from 'react'

// MUI
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Box from '@mui/material/Box'

import RichText, { IRichText } from '../RichText'
import trackingEvent, { AccordionInfo } from '../../utils/trackingEvent'
import ParrotfishIcon from '../ParrotfishIcon'
import HelpImage from '../Image/Variants/HelpImage'
import CodeModule from '../CodeModule'
import { ContentfulToComponent, ContentfulToComponentProps } from '../RichText/types'

export type AccordionComponentProps = Queries.ACCORDIONFragment
const AccordionComponent: React.FC<AccordionComponentProps> = data => {
  const propsMap: Partial<ContentfulToComponentProps> = {
    HelpUniverseComponentImage: <HelpImageProps,>(props: HelpImageProps) => ({
      ...(props as unknown as HelpImageProps),
    }),
    HelpUniverseModuleDynamicComponents: <CodeModuleComponentProps,>(props: CodeModuleComponentProps) => ({
      ...(props as unknown as CodeModuleComponentProps),
    }),
  } as const

  const accordionComponentMap: Partial<ContentfulToComponent> = {
    'HelpUniverseComponentImage': HelpImage,
    'HelpUniverseModuleDynamicComponents': CodeModule,
  } as const

  const { title, body, summaryIcon } = data
  const [expanded, setExpanded] = React.useState<string | false>(false)

  const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false)
    const accordionTrackingPayload: AccordionInfo = {
      name: `${title}`,
    }
    isExpanded && trackingEvent({ event: 'accordion_open', accordion: accordionTrackingPayload })
  }

  return (
    <Box>
      <Accordion expanded={expanded === 'panel'} onChange={handleChange('panel')} variant={'outlined'}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel-content" id="panel-header">
          {summaryIcon && <ParrotfishIcon {...summaryIcon} />}
          <Typography variant="subtitle1" lineHeight={1.5}>
            {title}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <RichText
            {...(body as IRichText)}
            componentMap={accordionComponentMap as ContentfulToComponent}
            propsMap={propsMap as ContentfulToComponentProps}
          />
        </AccordionDetails>
      </Accordion>
    </Box>
  )
}

export default AccordionComponent
